export var FontSizeData_fontType;
(function (FontSizeData_fontType) {
    FontSizeData_fontType["PX"] = "PX";
    FontSizeData_fontType["EM"] = "EM";
    FontSizeData_fontType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(FontSizeData_fontType || (FontSizeData_fontType = {}));
//# sourceMappingURL=decoration_fontsize.enums.js.map